import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import AWS from "aws-sdk";
import { v4 as uuidv4 } from "uuid";

const Register = () => {
	let { id } = useParams();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [img, setImg] = useState("");
	const [imgUrl, setImgUrl] = useState("");
	const [imgName, setImgName] = useState("");
	const [progress, setProgress] = useState(0);
	const [uploading, setUploading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const [nameError, setNameError] = useState(false);
	const [emailError, setEmailError] = useState(false);
	const [imgError, setImgError] = useState(false);

	const S3_BUCKET = "azure-south-pms-s3";
	const REGION = "ap-southeast-1";

	AWS.config.update({
		accessKeyId: "AKIA3OCCLFRMD44NA2Z7",
		secretAccessKey: "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",
	});

	const myBucket = new AWS.S3({
		params: { Bucket: S3_BUCKET },
		region: REGION,
	});

	const handleFileInput = (e, updatePath, updateName, updateProgress) => {
		setUploading(true);
		let filename = `${uuidv4()}.${e.target.files[0].name.split(".").pop()}`;
		updateName(filename);

		const params = {
			Body: e.target.files[0],
			Bucket: S3_BUCKET,
			Key: `fastpass_qr/${filename}`,
		};

		myBucket
			.putObject(params)
			.on("httpUploadProgress", (evt) => {
				updateProgress(Math.round((evt.loaded / evt.total) * 100));
			})
			.send((err) => {
				setUploading(false);
				updateProgress(0);
				if (err) {
					console.log(err);
				} else {
					updatePath(URL.createObjectURL(e.target.files[0]));
					setImgUrl(
						`https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${params.Key}`
					);
				}
			});
	};

	const registerUser = async (e) => {
		e.preventDefault();
		setLoading(true);
		setNameError(false);
		setEmailError(false);
		setImgError(false);
		setErrorMessage("");
		if (validate() === true) {
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					client_id: 1,
					transaction_id: id,
					name: name,
					email: email,
					id_photo: imgUrl,
				}),
			};

			const response = await fetch(
				`${process.env.REACT_APP_API_URI}/transactions/g/`,
				requestOptions
			);
			const data = await response.json();

			if (!response.ok) {
				setErrorMessage(data.msg);
			} else {
				navigate(`/qr/exit/${data.transaction_id}`);
			}
		}
		setLoading(false);
	};

	const validate = () => {
		if (!name || !email || !imgUrl) {
			setErrorMessage("Please fill out all required fields.");
			if (!name) {
				setNameError(true);
			}
			if (!email) {
				setEmailError(true);
			}
			if (!imgUrl) {
				setImgError(true);
			}
			return false;
		} else {
			return true;
		}
	};

	return (
		<>
			<div className="guest-content full-page full">
				<Container>
					<div className="form-container flex-column full-page">
						<Form
							onSubmit={registerUser}
							className="input-form bg-white rounded col-lg-5 col-md-8 col-12"
						>
							<div className="align-center mb-4">
								<h1 className="title-md text-regular-lexend mb-0 upper">
									Register
								</h1>
							</div>
							<div className="register-info form-block rounded">
								<p className="m-0 text-sm">
									You won't have to do this step next time you visit a{" "}
									<a href="#" className="text-dark text-medium-inter">
										Fastpass enabled property.
									</a>
								</p>
							</div>
							<Row className="form-block">
								<Col>
									<Form.Label>Name</Form.Label>
									<Form.Control
										className={`form-input rounded ${nameError && "error"}`}
										placeholder="Enter your name"
										value={name}
										onChange={(e) => setName(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Email</Form.Label>
									<Form.Control
										type="email"
										className={`form-input rounded ${emailError && "error"}`}
										placeholder="Enter your email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Valid ID</Form.Label>
									<div
										className={`img-preview border rounded full flex-column ${
											imgError && "error"
										}`}
										style={{
											background: img ? `url(${img})` : "#ddd",
										}}
										onClick={() => document.getElementById("img").click()}
									>
										{!img && !uploading && (
											<div className="flex-column">
												<i className="ri-upload-2-line" />
												<span className="text-sm">Upload</span>
											</div>
										)}
										{uploading && (
											<>
												<div className="upload-progress-overlay" />
												<div
													className="upload-progress-bar"
													style={{
														width: `${progress < 20 ? 20 : progress}%`,
													}}
												>
													<div className="upload-progress-pulse bg-white" />
												</div>
											</>
										)}
									</div>
									<input
										type="file"
										className="hidden"
										id="img"
										accept="image/png, image/jpeg"
										onChange={(e) =>
											handleFileInput(e, setImg, setImgName, setProgress)
										}
									/>
								</Col>
							</Row>
							{errorMessage && (
								<Row className="form-block">
									<Col>
										<span className="form-error-msg text-red">
											{errorMessage}
										</span>
									</Col>
								</Row>
							)}
							<Row>
								<Col>
									<Button
										type="submit"
										className="btn-default rounded full btn-lg upper text-medium-inter text-md"
										disabled={loading}
									>
										{loading ? "Submitting" : "Submit"}
									</Button>
								</Col>
							</Row>
						</Form>
					</div>
				</Container>
			</div>
		</>
	);
};

export default Register;
